import { ReactComponent as Pimprenelle } from './pimprenelle.svg'
import { ReactComponent as Ratp } from './ratp.svg'
import { ReactComponent as AddCircle } from './add-circle.svg'
import { ReactComponent as CheckCircle } from './check-circle.svg'
import { ReactComponent as Close } from './close.svg'
import { ReactComponent as ArrowRight } from './arrow-right.svg'
import { ReactComponent as Alert } from './alert.svg'
import { ReactComponent as ChevronLeft } from './chevron-left.svg'
import { ReactComponent as ChevronRight } from './chevron-right.svg'
import { ReactComponent as ChevronDown } from './chevron-down.svg'
import { ReactComponent as ChevronUp } from './chevron-up.svg'
import { ReactComponent as Loading } from './loading.svg'
import { ReactComponent as PlusCircle } from './plus-circle.svg'
import { ReactComponent as MinusCircle } from './minus-circle.svg'
import { ReactComponent as Trash } from './trash.svg'
import { ReactComponent as Email } from './email.svg'
import { ReactComponent as ExclamationCircle } from './exclamation-circle.svg'
import { ReactComponent as Checkbox } from './check-box.svg'
import { ReactComponent as CheckedBox } from './checked-box.svg'
import { ReactComponent as Record } from './record.svg'
import { ReactComponent as CreditCard } from './credit-card.svg'
import { ReactComponent as Setting } from './settings.svg'
import { ReactComponent as Check } from './check.svg'
import { ReactComponent as ArrowUp } from './arrow-up.svg'
import { ReactComponent as ArrowDown } from './arrow-down.svg'
import { ReactComponent as Shutdown } from './shutdown.svg'
import { ReactComponent as SortUp } from './sort-up.svg'
import { ReactComponent as SortDown } from './sort-down.svg'
import { ReactComponent as Payment } from './payment.svg'
import { ReactComponent as Control } from './control.svg'
import { ReactComponent as Look } from './look.svg'
import { ReactComponent as File } from './file.svg'
import { ReactComponent as Eye } from './eye.svg'
import { ReactComponent as Loop } from './loop.svg'
import { ReactComponent as CloseCircle } from './close-circle.svg'
import { ReactComponent as People } from './people.svg'
import { ReactComponent as DashCircle } from './dash-circle.svg'
import { ReactComponent as AuditOk } from './audit-ok.svg'
import { ReactComponent as AuditKo } from './audit-ko.svg'

const svgs = {
  pimprenelle: Pimprenelle,
  ratp: Ratp,
  add_circle: AddCircle,
  // check: Check,
  plus_circle: PlusCircle,
  minus_circle: MinusCircle,
  trash: Trash,
  loading: Loading,
  // loading_inverse: LoadingWhite,
  check_circle: CheckCircle,
  arrow_right: ArrowRight,
  arrow_up: ArrowUp,
  arrow_down: ArrowDown,
  close: Close,
  alert: Alert,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  chevron_down: ChevronDown,
  chevron_up: ChevronUp,
  email: Email,
  exclamation_circle: ExclamationCircle,
  checkbox: Checkbox,
  checkedbox: CheckedBox,
  record: Record,
  credit_card: CreditCard,
  setting: Setting,
  check: Check,
  shutdown: Shutdown,
  sort_up: SortUp,
  sort_down: SortDown,
  payment: Payment,
  control: Control,
  look: Look,
  file: File,
  eye: Eye,
  loop: Loop,
  close_circle: CloseCircle,
  dash_circle: DashCircle,
  // edit: Edit
  people: People,
  audit_ok: AuditOk,
  audit_ko: AuditKo
}

const getSrc = (key) => {
  return svgs[key] ? svgs[key] : key
}

export default svgs
export { getSrc }
